export function getNowAndAName() {
  const now = new Date();
  const locale = window.navigator.language;

  return {
    now: `${now.getTime()}`,
    augmentedName: now.toLocaleString(locale),
  };
}
